var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-success"},[_c('div',[_vm._v(" 설문에 응해주셔서 감사합니다. ")]),_c('button',{staticClass:"button",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" 제출한 답변 확인하기 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }